<template>
	<div class="answer-box panel gray-small-square-1" :class="{ 'lg': large }">

		<div class="shadow left"></div>
		<div class="shadow top"></div>
		<div class="shadow right"></div>
		<div class="shadow bottom"></div>

		<div class="body">
			<div 
			v-if="pergunta != null" 
			class="pergunta">

			<div class="enunciado">
				<span>{{ currentNumber }}</span> {{ pergunta.Enunciado }}
			</div>

			<div class="opcoes">
				<div v-for="(opcao, index) in opcoesPergunta" class="opcao" :class="{ 'correta': opcao.Correta }">
					<radio 
					:disabled="locked"
					:key="opcao.Id + pergunta.Id"
					@checked="respondeu" 
					:checked="pergunta.RespostaId == opcao.Id" 
					:name="pergunta.Id" 
					:value="opcao.Id" 
					:text="opcao.Referencia"></radio>
				</div>
			</div>
		</div>
		<div class="buttons">
			<div class="center">
				<strong>{{ this.currentNumber }}</strong> / {{ part.Perguntas.length }}
			</div>
			<button @click="previous" class="btn btn-gray previous left">Previous</button>
			<next :locked="locked" :click="next" :is-last-page="!hasNext()" :part="part"></next>
		</div>
	</div>
</div>
</template>

<script>
import bus from '@/bus/event-bus.js'
import next from '../ui/NextButton'

export default {
	props: ['part', 'large', 'locked'],

	data() {
		return {
			partId: null,
			pergunta: null,
			currentNumber: 1
		}
	},

	computed: {
		opcoes() {
			return this.part.Opcoes
		},

		opcoesPergunta() {
			return this.getOpcoesPergunta()
		},
	},

	mounted() {
		this.setByNumber(1)
	},

	methods: {

		setByNumber(i) {
			this.pergunta = this.part.Perguntas[i-1]
			this.partId = this.part.PartId
			this.currentNumber = i
		},

		respondeu(opcaoId) {
			this.pergunta.RespostaId = opcaoId
			this.pergunta.Respondeu = true
			bus.$emit('respondeu', opcaoId, this.pergunta.Id)
		},

		getOpcoesPergunta() {
			var opcoes = this.pergunta.Opcoes
			var refs = opcoes.map((o) => o.Referencia)

			this.opcoes.forEach((o) => {
				if(!refs.includes(o.Referencia)) {
					opcoes.push(o)
				}
			})

			return opcoes.sort((a, b) => this.compare(a, b))
		},

		next() {
			if(this.hasNext()) {
				var next = this.currentNumber + 1
				this.setByNumber(next)
				this.$emit('page-changed', next)
			} else {
				bus.$emit('next.part');
			}
		},

		previous() {
			if(this.hasPrevious()) {
				var prev = this.currentNumber - 1
				this.setByNumber(prev)
				this.$emit('page-changed', prev)
			} else {
				bus.$emit('previous.part');
			}			
		},

		hasNext() {
			return this.currentNumber < this.part.Perguntas.length
		},

		hasPrevious() {
			return this.currentNumber > 1;
		},

		compare(a, b) {
			const refA = a.Referencia.toUpperCase();
			const refB = b.Referencia.toUpperCase();

			let comparison = 0;
			if (refA > refB) {
				comparison = 1;
			} else if (refA < refB) {
				comparison = -1;
			}
			return comparison;
		},


	},
	components: {
		'next': next
	}
}
</script>


// WEBPACK FOOTER //
// src/components/perguntas/RelacioneAnswerBox.vue